import { useCms } from '~/components/hooks/useCms';

export const useOrgNameLabel = (text: string): string => {
  const { userOrganization } = useCms();

  return `${userOrganization.name} ${text}`;
};
